export const GetInTouch = (props) => {
    return (
        <div className="contact-container">
        <h1 className="contact-title">Get in touch</h1>
        <p className="contact-description">
          Want to get in touch? We'd love to hear from you. Here's how you can reach us...
        </p>
        <div className="contact-cards">
          <div className="contact-card">
            <div className="contact-icon">📞</div>
            <h2>Talk to Sales</h2>
            <p>Get in touch with our Sales Team today for expert advice and Personalized AC/Water Purifier solutions that fit your needs and budget</p>
            <a href="tel:8920455953" className="contact-link">+91-8920455953</a>
          </div>
          <div className="contact-card">
            <div className="contact-icon">💬</div>
            <h2>Contact Customer Support</h2>
            <p>Need assistance? Contact our Customer Support team at Service Center Hyderabad for prompt help and service inquiries. We're here to assist you!</p>
            <a onClick={() => {
              window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
              });
            }}
            className="contact-link">Contact Support</a>
          </div>
        </div>
      </div>
    )
}